import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { ReportFragment, REPORT_FRAGMENT } from "../../fragments";
import { ReportQueryVariables } from "../../types";

export const GET_REPORT = gql`
  query getReport($id: ID!) {
    report(id: $id) {
      ...ReportFragment
    }
  }
  ${REPORT_FRAGMENT}
`;

export type ReportData = { report: ReportFragment };

export default (
  options?: QueryHookOptions<ReportData, ReportQueryVariables>
) => {
  return useQuery<ReportData, ReportQueryVariables>(GET_REPORT, options);
};
